<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue'
import { gsap } from 'gsap'

const props = defineProps({
	reverse: {
		type: Boolean,
		default: false,
	},
	active: {
		type: Boolean,
		default: true,
	},
	speed: {
		type: Number,
		default: 20,
	},
})

const tickerItems = ref([
	{
		image: 'https://cdn.papercrowns.com/website/images/elements/ticker/paper-crowns.svg',
		alt: 'Paper Crowns Logo',
	},
	{
		image: 'https://cdn.papercrowns.com/website/images/elements/ticker/crossed-swords.png',
		alt: 'Paper Crowns Tower',
	},
	{
		image: 'https://cdn.papercrowns.com/website/images/elements/ticker/visionaries.svg',
		alt: 'Paper Crowns Tower',
	},
	{
		image: 'https://cdn.papercrowns.com/website/images/elements/ticker/pc-re.svg',
		alt: 'PC-RE Pills',
	},
	{
		image: 'https://cdn.papercrowns.com/website/images/elements/ticker/reimagine-everything.svg',
		alt: 'Reimagine Everything',
	},
	{
		image: 'https://cdn.papercrowns.com/website/images/elements/ticker/tower.png',
		alt: 'Paper Crowns Tower',
	},
	{
		image: 'https://cdn.papercrowns.com/website/images/elements/ticker/est-2019.svg',
		alt: 'Established 2019',
	},
	{
		image: 'https://cdn.papercrowns.com/website/images/elements/ticker/20-19.svg',
		alt: '20-19 Pills',
	},
])

const ticker = ref(null)
const marquee = ref(null)

const startMarquee = () => {
	if (!ticker.value) return

	if (marquee.value) {
		marquee.value.kill()
	}

	marquee.value = gsap.to(ticker.value, {
		x: (props.reverse ? 1 : -1) * 100 + '%',
		duration: props.speed,
		ease: 'none',
		repeat: -1,
	})
}

const stopMarquee = () => {
	if (marquee.value) {
		marquee.value.pause()
	}
}

const resumeMarquee = () => {
	if (marquee.value) {
		marquee.value.resume()
	}
}

onMounted(() => {
	if (props.active) {
		startMarquee()
	}
})

onUnmounted(() => {
	if (marquee.value) {
		marquee.value.kill()
	}
})

watch(
	() => props.reverse,
	() => {
		if (props.active) {
			startMarquee()
		}
	},
)

watch(
	() => props.active,
	(newActive) => {
		if (newActive) {
			if (marquee.value) {
				resumeMarquee()
			} else {
				startMarquee()
			}
		} else {
			stopMarquee()
		}
	},
)
</script>

<template>
	<div class="group overflow-hidden">
		<div ref="ticker" :class="[reverse ? 'flex-row-reverse' : 'flex-row', 'flex h-full w-full gap-2']">
			<img v-for="item in tickerItems" class="h-full" :src="item.image" :alt="item.alt" />
			<img v-for="item in tickerItems" class="h-full" :src="item.image" :alt="item.alt" />
		</div>
	</div>
</template>
